<template>
  <section class="mb-6 pb-5">
    <div class="columns is-justify-content-center">
      <div class="column">
        <header class="mb-6 px-6 pb-6">
          <div class="columns is-justify-content-center">
            <div class="column is-5 mb-5">
              <h1 class="is-size-1 has-text-weight-semibold has-text-centered">
                {{ title }}
              </h1>
            </div>
          </div>
          <div class="columns is-justify-content-center">
            <div class="column is-6">
              <p class="has-text-centered is-size-3">
                {{ description }}
              </p>
            </div>
          </div>
          <div class="columns is-justify-content-center mt-5">
            <div class="column is-6 has-text-centered">
              <ButtonView
                @click="scrollToCalculator"
                icon-left="cls-arrow-down"
                class="has-text-primary has-border-primary"
                :data-e2e="TaxCypressAttribute.buttons.JUMP_TO_CALCULATOR"
              >
                {{ $t('tax.calculator-jump-to') }}
              </ButtonView>
            </div>
          </div>
        </header>
        <section class="has-background-secondary p-6">
          <div class="columns is-justify-content-center m-b-50">
            <div class="column is-3">
              <h2 class="is-size-2 has-text-weight-semibold">
                {{ finalTaxReturnTitle }}
              </h2>
            </div>
            <div class="column is-3">
              <p class="is-size-4">
                {{ finalTaxReturnDescription }}
              </p>
            </div>
          </div>
          <div class="columns is-justify-content-center">
            <div class="column is-3">
              <h2 class="is-size-2 has-text-weight-semibold">
                {{ finalReturnTitle }}
              </h2>
            </div>
            <div class="column is-3">
              <p class="is-size-4">{{ finalReturnDescription }}</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
import Lang from '@/modules/core/app/services/Lang';
import { TaxCypressAttribute } from '@/modules/tax/constants/TaxCypressAttribute';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FinalTaxesDescriptionContent',
  emits: ['scroll-to-calculator'],
  components: { ButtonView },
  props: {
    title: {
      type: String,
      default: () => Lang.t('tax.final-taxes-calculator')
    },
    description: {
      type: String,
      default: () => Lang.t('tax.final-taxes-calculator-description')
    },
    finalTaxReturnTitle: {
      type: String,
      default: () => Lang.t('tax.what-final-tax-return')
    },
    finalTaxReturnDescription: {
      type: String,
      default: () => Lang.t('tax.final-tax-return-desc')
    },
    finalReturnTitle: {
      type: String,
      default: () => Lang.t('tax.final-return-title')
    },
    finalReturnDescription: {
      type: String,
      default: () => Lang.t('tax.final-return-desc')
    }
  },
  static: {
    TaxCypressAttribute
  },
  methods: {
    scrollToCalculator() {
      this.$emit('scroll-to-calculator');
    }
  }
};
</script>

<style scoped>
.is-size-1 {
  font-size: var(--ce-48px) !important;
}
</style>
